let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("e9stW"), load("6Tuw7"), load("KSMZE")]).then(() => parcelRequire('jFrMf'));